import { SeoHead } from "@/components/SeoHead";
import { Navigation } from "@/components/Navigation";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { Hero, HeroAudience } from "@/components/Hero";
import { DoorBand } from "@/components/DoorBand";
import { ProofStrip } from "@/components/ProofStrip";
import { TrustBadges } from "@/components/TrustBadges";
import { PainSection } from "@/components/PainSection";
import { SolutionSection } from "@/components/SolutionSection";
import { ApprovalFlowVisual } from "@/components/dowod/ApprovalFlowVisual";
import { KISBenefit } from "@/components/KISBenefit";
import { Features } from "@/components/Features";
import { SupportedForms } from "@/components/SupportedForms";
import { HowItWorks } from "@/components/HowItWorks";
import { CTASection } from "@/components/CTASection";
import { Pricing } from "@/components/Pricing";
// import { Testimonials } from "@/components/Testimonials"; // No users yet
import { VCWedge } from "@/components/VCWedge";
import { FAQ } from "@/components/FAQ";
import { ComplianceBox } from "@/components/ComplianceBox";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";
import { StickyMobileCta } from "@/components/StickyMobileCta";
import { GhostMascot } from "@/components/GhostMascot";
import { ReadWithAI } from "@/components/ReadWithAI";
import { useTranslation } from "@/i18n/i18n";

const seoContent = {
  pl: {
    title: "Bookeper AI: Księgowość AI dla JDG",
    description:
      "Bookeper przygotowuje deklaracje z Twoich danych — sprawdzasz i zatwierdzasz każdą przed złożeniem. Nie zastępuje doradcy podatkowego. Otwarta beta: 0 zł, bez karty.",
  },
  en: {
    title: "Bookeper AI: AI Accounting for Sole Traders in Poland",
    description:
      "Bookeper prepares declarations from your data — you review and approve each one before filing. It does not replace a tax advisor. Open beta: PLN 0, no card.",
  },
  uk: {
    title: "Bookeper AI: AI-бухгалтерія для ФОП у Польщі",
    description:
      "Bookeper готує декларації з Ваших даних — Ви перевіряєте й затверджуєте кожну перед поданням. Не замінює податкового радника. Відкрита бета: 0 зл, без картки.",
  },
} as const;

const HOME_CANONICAL = {
  pl: "https://www.bookeper.pl/",
  en: "https://www.bookeper.pl/en",
  uk: "https://www.bookeper.pl/uk",
} as const;

const Index = () => {
  const { locale } = useTranslation();
  const seo = seoContent[locale];
  const canonical = HOME_CANONICAL[locale];

  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <SeoHead>
        <html lang={locale} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={canonical} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href={canonical} />
        <link rel="alternate" hrefLang="pl" href="https://www.bookeper.pl/" />
        <link rel="alternate" hrefLang="en" href="https://www.bookeper.pl/en" />
        <link rel="alternate" hrefLang="uk" href="https://www.bookeper.pl/uk" />
        <link rel="alternate" hrefLang="x-default" href="https://www.bookeper.pl/" />
      </SeoHead>
      <AnnouncementBar />
      <Navigation />
      <main>
        <Hero />
        <DoorBand />
        <HeroAudience />
        <ProofStrip />
        <ReadWithAI page="index" />
        <TrustBadges />

        {/* Ghost waving - welcoming after hero */}
        <div className="py-4 flex justify-center opacity-50">
          <GhostMascot size="sm" variant="waving" showGlow={false} />
        </div>

        <PainSection />
        <SolutionSection />
        {/* BOO-3240 U6: the human-confirms mechanic as a visual proof moment,
            directly under the engines-vs-chat comparison. */}
        <section aria-label="approval-flow" className="px-6 md:px-8 py-12">
          <div className="max-w-2xl mx-auto">
            <ApprovalFlowVisual />
          </div>
        </section>
        <KISBenefit />

        <Features />
        <SupportedForms />

        <div id="jdg">
          <CTASection />
        </div>
        <HowItWorks />

        {/* Ghost calculating - money/numbers theme before pricing */}
        <div className="py-4 flex justify-center opacity-50">
          <GhostMascot size="sm" variant="calculating" showGlow={false} />
        </div>

        <Pricing />

        <VCWedge />
        {/* DEFERRED: Roadmap section hidden 2026-07-03 because Fider is offline
            and static vote copy points at that portal. Phase gate:
            fider-restoration-or-removal. NOT dead code: restore <Roadmap />
            once BOO-3231 resolves the portal. See
            docs/engineering/deferred-capabilities.md. Linear: BOO-3231. */}

        <FAQ />
        <ComplianceBox />
      </main>
      <Footer />
      <StickyMobileCta />
      <CookieConsent />
    </div>
  );
};
export default Index;
